import React, { useState } from 'react';
import './App.css'
import Body from "./components/body/body"

function App() {

  return (
    <div className='App'>
    <Body />
    </div>
  );
}

export default App;
